import Axios from "axios"

// vote-menu.js
;(({ $, $$, log }) => {
    $$('.comment__vote-menu').forEach(vm => {
        const like = vm.querySelector('.vote-menu__like')
        const dislike = vm.querySelector('.vote-menu__dislike')

        if (!like || !dislike) {
            return
        }

        const buttons = [like, dislike]

        // log(like, dislike)

        const API = vm.dataset.url
        const commmentID = vm.dataset.commentId
        const userID = vm.dataset.userId

        // log(API, commmentID, userID)

        buttons.forEach(b => {
            const type = 
            b.addEventListener('click', async () => 
                handleResponse(await makeReques(API, commmentID, userID, b?.dataset?.type)))
        })

    })

    async function makeReques(url, comment_id, user_id, type) {
        try {
            return await Axios.get(url, {
                params: { comment_id, user_id, type }
            })
        } catch (err) {
            // log(err.response)
        }
    }

    function handleResponse(response) {
        // log('response', response)

        const { data } = response

        const {
            dislike,
            dislike_count,
            id,
            like,
            like_count,
            success
        } = data

        if (!success) {
            return
        }

        const voteMenu = $(`.vote-menu[data-comment-id="${id}"]`)
        if (!voteMenu) {
            return
        }

        const likeEl = voteMenu.querySelector('.vote-menu__like')
        const dislikeEl = voteMenu.querySelector('.vote-menu__dislike')
        if (!likeEl || !dislikeEl) {
            return
        }

        const likeActiveClass = 'vote-menu__like--active'
        const dislikeActiveClass = 'vote-menu__dislike--active'
    
        likeEl.innerText = like_count
        dislikeEl.innerText = dislike_count

        if (like) {
            likeEl.classList.add(likeActiveClass)
        } else {
            likeEl.classList.remove(likeActiveClass)
        }

        if (dislike) {
            dislikeEl.classList.add(dislikeActiveClass)
        } else {
            dislikeEl.classList.remove(dislikeActiveClass)
        }
    }
})(CNS);